import { Component, ViewChild, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NgModel } from '@angular/forms';
import { BaseControlComponent } from '../base/base-control.component';
import { SelectorService } from '../base/selector.service';
@Component({
  // moduleId: module.id,
  selector: 'ssg-swichbox',
  templateUrl: 'swichbox.component.html',
  styleUrls: ['swichbox.component.scss'],
})
export class SwichBoxComponent extends BaseControlComponent<string> {
  @Input() icon: string;
  @Input() appearance: string;
  @Input() size: string;
  @Input() buttontype: string;
  @Input() check: boolean;
  @Output() valueChange = new EventEmitter<any>();
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  change(value: boolean) {
      this.valueChange.emit(value);
  }
}
